import { Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";

import { DownloadIcon } from "@/Components/Icons/DownloadIcon";
import { TOOLTIPTEXT } from "@/utilities/CommonText";
import useDebounceScroll from "@/utilities/hooks/useDebounceScroll";

import {
  fetchDownloads,
  setLoading,
  updatePagination,
  updateSorting,
} from "../../../../reducers/clientDownloads";
import { getColumnNormalHtml } from "../../../../utilities/datatable/columnFunctions";
import TableLoader from "../../TableLoader";
import TableNoContent from "../../TableNoContent";

const DownloadsList = () => {
  const { pagination, isLoading, downloads, sorting } = useSelector(
    (state) => state.clientDownloads,
  );
  const dispatch = useDispatch();
  const columns = [
    {
      name: "Name",
      sortable: true,
      sortField: "reportName",
      selector: (row) => (
        <div className="ml-4">{getColumnNormalHtml(row.reportName)}</div>
      ),
      width: "40%",
    },
    {
      name: "Date",
      sortable: true,
      sortField: "created_at",
      // DD-MM-YYYY HH:mm:ss
      selector: (row) => (
        <div>
          {getColumnNormalHtml(
            moment(row.reportDate, "YYYY-MM-DD HH:mm:ss").format(
              "DD MMMM, YYYY, hh:mm A",
            ),
          )}
        </div>
      ),
      width: "30%",
    },
    {
      name: "Action",
      sortable: false,
      selector: (row) => (
        <div className="ml-4 text-wrap">
          <Tooltip title={TOOLTIPTEXT.download}>
            <a className="text-primary" href={row.reportFile} download>
              <DownloadIcon />
            </a>
          </Tooltip>
        </div>
      ),
      width: "30%",
    },
  ];

  const dataTableRef = useRef();
  // Handles the table scroll event ...
  const handleDebounceScroll = useDebounceScroll(() =>
    dispatch(fetchDownloads({})),
  );
  useEffect(() => {
    if (dataTableRef.current) {
      const table = dataTableRef.current.querySelector("._DataTable");
      table.addEventListener("scroll", handleDebounceScroll);
      return () => {
        table.removeEventListener("scroll", handleDebounceScroll);
      };
    }
  }, [handleDebounceScroll]);

  const handleSort = ({ sortField: newSortField }) => {
    const { sortByColumn, sortByOrder } = sorting; // get from Redux

    let newSortOrder = "asc";
    if (sortByColumn === newSortField) {
      newSortOrder = sortByOrder === "asc" ? "desc" : "asc";
    }

    dispatch(
      updateSorting({ sortByColumn: newSortField, sortByOrder: newSortOrder }),
    );
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setLoading(true));
    dispatch(fetchDownloads());
  };
  return (
    <div className="DownloadsList_Wrapper mb-[52px]">
      <div className="flex h-full flex-col rounded-[10px] bg-white p-4 shadow-[0px_x1px_6px_0px_#E7EFFB]">
        <div className="mb-[20px] flex flex-col flex-wrap gap-3 border-b border-b-[#E8E8E8] pb-[11px] md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-2 md:gap-[21px]">
            <h4 className="tour-applocum-download-clientsidebar text-[20px] font-medium leading-[normal] text-black">
              Downloads
            </h4>
          </div>
        </div>
        <div
          className="DataTable_Wrapper hide_extended_arrow"
          ref={dataTableRef}
        >
          <DataTable
            columns={columns}
            data={downloads}
            fixedHeader
            onSort={handleSort}
            // persistTableHead={true}
            fixedHeaderScrollHeight="600px"
            progressPending={isLoading}
            progressComponent={<TableLoader rows={5} />}
            noDataComponent={<TableNoContent />}
            className="_DataTable"
          />
        </div>
      </div>
    </div>
  );
};

export default DownloadsList;
